<template>
    <div>
        <modal name="rgpd-modal">
            <div class="p-5">
                <h1 class="mb-2 text-xl font-bold">{{$t('inscription.conditions_d_utilisation')}}</h1>
                <hr class="my-3">
                <div v-html="$t('inscription.rgpd', {
                    hostname: hostname,
                    shop: this.$companyTool.confFile().name,
                    email: email
                })"></div>
                <button @click="$modal.hide('rgpd-modal')" class="p-2 px-4 mt-5 text-sm font-light duration-200 bg-red-300 hover:bg-red-400 rounded-xl">
                    <i class="fa-solid fa-times mr-0.5"></i> {{$t('inscription.fermer')}}
                </button>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        computed: {
            hostname() {
                if (!this.$companyTool.confFile().api_keyname || this.$companyTool.confFile().api_keyname == 'savinfo') {
                    return 'SavInfo'
                }
                return 'SAS Savlog'
            },
            email() {
                if (!this.$companyTool.confFile().api_keyname || this.$companyTool.confFile().api_keyname == 'savinfo') {
                    return 'rgpd@savinfo.fr'
                }
                return 'rgpd@savlog.net'
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/SavRgpdModal.vue